
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"none","height":"14","viewBox":"0 0 17 14","width":"17","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"m9.55539.333496c-3.68148 0-6.66666 2.985184-6.66666 6.666664h-2.222226l2.881486 2.88148.05185.10371 2.99259-2.98519h-2.22222c0-2.86666 2.31852-5.18518 5.18518-5.18518 2.86671 0 5.18521 2.31852 5.18521 5.18518 0 2.86667-2.3185 5.18514-5.18521 5.18514-1.42963 0-2.72592-.5851-3.65926-1.5259l-1.05185 1.0519c1.20741 1.2074 2.86667 1.9555 4.71111 1.9555 3.68151 0 6.66671-2.9852 6.66671-6.66664 0-3.68148-2.9852-6.666664-6.66671-6.666664zm-.74074 3.703704v3.7037l3.14815 1.86667.5704-.94815-2.60744-1.54815v-3.07407z","fill":"#4a3428"}})])
          )
        }
      }
    